import { themeQuartz } from 'ag-grid-community';

// to use myTheme in an application, pass it to the theme grid option
const gridTheme = themeQuartz
	.withParams({
        browserColorScheme: "light",
        fontFamily: "IBM Plex Sans, Arial, sans-serif",
        fontSize: 14,
        headerFontSize: 14
    });
export default gridTheme;